import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { LanguageContext } from '../../components/LanguageContext';

function withLanguage () {
  return Inner => {
    class WithLanguage extends React.PureComponent {
      static displayName = `Language(${Inner.displayName || Inner.name || 'Component'})`;
      static contextType = LanguageContext;
      static propTypes = {
        forwardedRef: PropTypes.any
      };

      render () {
        const { forwardedRef, ...rest } = this.props;
        const value = this.context || {};

        return (
          <Inner
            {...rest}
            ref={forwardedRef}
            language={value.language}
            setLanguage={value.setLanguage}
            t={value.t}
          />
        );
      }
    }

    const Wrapped = React.forwardRef((props, ref) => (
      <WithLanguage {...props} forwardedRef={ref} />
    ));

    return hoistNonReactStatics(Wrapped, Inner);
  };
}

export { withLanguage };
